import { Chip, Stack, Typography, useTheme } from "@mui/material";
import { addTransparency } from "../../../../application/styles/colorStyles";



export const InfluenceLabel = ({ influence }: { influence?: number }) => {
  const theme = useTheme();


  const getInfluenceLabe = (influence?: number): { color: string, label: string } => {
    if (influence === undefined) return { color: theme.palette.text.secondary, label: 'unknown' };

    if (influence > 0.75) return { color: theme.palette.success.main, label: `strong` };
    if (influence > 0.5) return { color: theme.palette.warning.main, label: `moderate` };
    if (influence > 0.25) return { color: theme.palette.error.main, label: `weak` };
    if (influence > 0) return { color: theme.palette.error.main, label: `very weak` };

    return { color: theme.palette.text.secondary, label: `none` };
  }


  return (
    <Stack direction="row" spacing={1} justifyContent="flex-start" alignItems="center">

      <Typography variant="body2" color="text.secondary">
        {influence !== undefined ? (
          `${(influence * 100).toFixed(0)}% `
        ) : (
          'unknown '
        )}

        influence

      </Typography>

      <div
        style={{
          backgroundColor: addTransparency(getInfluenceLabe(influence).color, 0.2),
          padding: '2px 8px',
          borderRadius: '100px',
          color: getInfluenceLabe(influence).color,
        }}
      >
        <Typography variant="caption" color="inherit">
          {getInfluenceLabe(influence).label}
        </Typography>
      </div>
    </Stack>
  );
};